export const wordKeysProps = [
  {
    id: 'ou',
    label: 'ou',
    labelType: 'raw',
    mathfieldInstructions: {
      content: '\\text{ ou }',
      method: 'write',
    },
    group: 'words',
  },
  {
    id: 'et',
    label: 'et',
    labelType: 'raw',

    mathfieldInstructions: {
      content: '\\text{ et }',
      method: 'write',
    },
    group: 'words',
  },
]
